import {createContext, useContext} from "react";
import type {usePlayerViewPortSync} from "./usePlayerViewPortSync.ts";

export const PlayerViewPortContext = createContext<ReturnType<typeof usePlayerViewPortSync> | null>(null);
export function usePlayerViewPortSyncState() {
    const value = useContext(PlayerViewPortContext);
    if (!value) throw new Error("Player viewport requires PlayerViewPortProvider");
    return value;
}
/** Passive consumers receive only the viewport, never GM controls. */
export function usePlayerViewPort() {
    return usePlayerViewPortSyncState().playerViewPort;
}
